import React from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'react-styled-flexboxgrid-tmp'

import BuildingPreviewWithFav from 'Components/BuildingPreviewWithFav'

import NoFavourites from '../NoFavourites'

import {
  _BuildingPreviewCol,
} from './styles'

const FavBuildings = ({ favouriteBuildings, isFetching, userFavBuildingIdArr, userIsAuthentificated }) => (
  <Row top="xs">
    {
      favouriteBuildings && favouriteBuildings.length ?
        favouriteBuildings.map((building) => {
          if(userFavBuildingIdArr && userFavBuildingIdArr.includes(building.id)) {
            return (
              <_BuildingPreviewCol
                key={building.name}
              >
                <BuildingPreviewWithFav
                  building={building}
                  userIsAuthentificated={userIsAuthentificated}
                  isFavouritesPage
                  gaCategory="Favourites"
                />
              </_BuildingPreviewCol>
            )
          }
          return null
        })
        :
        <Col xs={12}>
          {
            isFetching ?
              'Loading...' :
              <NoFavourites building />
          }
        </Col>
    }
  </Row>
)

FavBuildings.propTypes = {
  favouriteBuildings: PropTypes.arrayOf(PropTypes.shape({})),
  isFetching: PropTypes.bool.isRequired,
  userFavBuildingIdArr: PropTypes.arrayOf(PropTypes.string),
  userIsAuthentificated: PropTypes.bool,
}

export default FavBuildings
